export default __webpack_public_path__ + "static/media/me3_ECAP_Classes_Icon.b6e8f24b.svg";